export default "__VITE_ASSET__CYhtV4SB__"